// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3B6-m","col":"styles_col__3dfJd"};